import { render } from "./UserSegmentHistory.vue?vue&type=template&id=64fd0178&scoped=true&ts=true"
import script from "./UserSegmentHistory.vue?vue&type=script&lang=ts"
export * from "./UserSegmentHistory.vue?vue&type=script&lang=ts"

import "./UserSegmentHistory.vue?vue&type=style&index=0&id=64fd0178&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64fd0178"]])

export default __exports__